import React, { FC } from "react";
import { useSelector } from "react-redux";
import { ContentBox, GridItem, GridLayout } from "ui-library/layouts";

import i18n from "core/i18n";
import { lettersNumbersBasicInterpunctionCharacters, max20Characters, max50Characters } from "core/form";
import { Field } from "core/hookForm";
import { Option } from "core/hookForm/components/Field";
import { getLocalizedCountryOptions } from "core/localized";

import { VehicleCancellationFormValues } from "../../types";

type AddressFieldsContainerProps = {
    sectionName: "contactPerson.address";
};

export const AddressFieldsContainer: FC<AddressFieldsContainerProps> = ({ sectionName }) => {
    const { t } = i18n.useTranslation();

    // TODO: refactor to non immutable version.
    const immutableCountryOptions = useSelector(getLocalizedCountryOptions);
    const countryOptions: Option[] = immutableCountryOptions.map((country) => ({
        code: country.get("value"),
        value: country.get("label"),
    }));

    return (
        <>
            <ContentBox fullWidth>
                <Field<VehicleCancellationFormValues>
                    name={`${sectionName}.street`}
                    input="textField"
                    label={t("holder.street")}
                    normalize={[lettersNumbersBasicInterpunctionCharacters, max50Characters]}
                />
            </ContentBox>

            <ContentBox fullWidth>
                <GridLayout spacing={2}>
                    <GridItem xs={12} md={6}>
                        <Field<VehicleCancellationFormValues>
                            name={`${sectionName}.descriptionNumber`}
                            input="textField"
                            label={t("holder.descriptionNumber")}
                            normalize={[lettersNumbersBasicInterpunctionCharacters, max20Characters]}
                        />
                    </GridItem>
                    <GridItem xs={12} md={6}>
                        <Field<VehicleCancellationFormValues>
                            name={`${sectionName}.orientationNumber`}
                            input="textField"
                            label={t("holder.orientationNumber")}
                            normalize={[lettersNumbersBasicInterpunctionCharacters, max20Characters]}
                        />
                    </GridItem>
                </GridLayout>
            </ContentBox>

            <ContentBox fullWidth>
                <GridLayout spacing={2}>
                    <GridItem xs={12} md={9}>
                        <Field<VehicleCancellationFormValues>
                            name={`${sectionName}.city`}
                            label={t("holder.city")}
                            input="textField"
                            normalize={[lettersNumbersBasicInterpunctionCharacters, max50Characters]}
                        />
                    </GridItem>
                    <GridItem xs={12} md={3}>
                        <Field<VehicleCancellationFormValues>
                            name={`${sectionName}.postalCode`}
                            input="textField"
                            label={t("holder.postalCode")}
                            normalize={[lettersNumbersBasicInterpunctionCharacters, max20Characters]}
                        />
                    </GridItem>
                </GridLayout>
            </ContentBox>

            <ContentBox fullWidth>
                <Field<VehicleCancellationFormValues>
                    name={`${sectionName}.countryCode`}
                    input="select"
                    label={t("holder.countryCode")}
                    options={countryOptions}
                />
            </ContentBox>
        </>
    );
};
